
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.965 28.307c5.74 0 10.409-4.649 10.409-10.364 0-5.714-4.67-10.364-10.409-10.364-5.739 0-10.408 4.65-10.408 10.364 0 5.715 4.66 10.364 10.408 10.364zm0-18.736c4.64 0 8.409 3.753 8.409 8.372 0 4.62-3.77 8.373-8.409 8.373-4.639 0-8.408-3.753-8.408-8.373-.01-4.62 3.769-8.372 8.408-8.372zM19.267 52.131h21.387c2.37 0 4.299-1.921 4.299-4.28v-3.634c0-.2-.02-.399-.07-.598-.66-7.656-7.209-13.64-14.928-13.64-7.719 0-14.268 5.984-14.927 13.64-.05.21-.07.408-.07.598v3.633c.01 2.35 1.94 4.281 4.309 4.281zm-2.3-7.924c0-.06.01-.13.03-.21l.03-.149c.54-6.66 6.23-11.877 12.938-11.877 6.71 0 12.398 5.217 12.948 11.877l.03.15c.02.08.03.149.03.209v3.633c0 1.265-1.03 2.29-2.3 2.29H19.287c-1.27 0-2.3-1.025-2.3-2.29v-3.633h-.02z"}})])
          )
        }
      }
    